export default __webpack_public_path__ + "static/rj-2a2f9441396b67dc9e8d9ecfec3c1788.webp";